import { db } from 'firebase/firebase';
import { collection,getDocs } from 'firebase/firestore';
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { getCollectionData } from 'packages/utils';

import { errorNotification } from 'appRedux/actions';

import {
  DIV_LIST_FETCH,
  divisionsListFetchError,
  divisionsListFetchSuccess,
} from '../actions/list';

const divisionsListFetchRequest = async organizationId =>
  getDocs(collection(db, 'organizations', organizationId, 'divisions')).then(getCollectionData);

function* divisionsListFetch({ payload: { organizationId } }) {
  try {
    const response = yield call(divisionsListFetchRequest, organizationId);
    yield put(divisionsListFetchSuccess(response));
  } catch (error) {
    yield put(divisionsListFetchError(error));
    yield put(errorNotification(error.toString()));
  }
}

export function* fetchList() {
  yield takeEvery(DIV_LIST_FETCH, divisionsListFetch);
}

export default function* rootSaga() {
  yield all([fork(fetchList)]);
}
